<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-card v-model="show" color="#013777">
                    <v-card-title>
                        <v-row>
                            <v-col cols="12" align="center">
                                <h3>
                                    <font color="white">
                                        COPA AMERICA 2024
                                    </font>
                                </h3>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" align="center">
                                <v-img max-height="150" max-width="150" src="images/copaamerica.jpg"></v-img>
                            </v-col>
                        </v-row>
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn icon @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                </v-card>
                <v-card>
                    <v-data-table :headers="headers" :items="partidosA" locale="es-ar" class="elevation-1"
                        :items-per-page="8" hide-default-footer dense>
                        <template v-slot:top>
                            <v-toolbar flat dense>
                                <v-toolbar-title center>
                                    <font color="Red">
                                        GRUPO A
                                    </font>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                    </v-data-table>
                    <v-data-table :headers="headers" :items="partidosB" locale="es-ar" class="elevation-1"
                        :items-per-page="8" hide-default-footer dense>
                        <template v-slot:top>
                            <v-toolbar flat dense>
                                <v-toolbar-title center>
                                    <font color="Red">
                                        GRUPO B
                                    </font>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                    </v-data-table>
                    <v-data-table :headers="headers" :items="partidosC" locale="es-ar" class="elevation-1"
                        :items-per-page="8" hide-default-footer dense>
                        <template v-slot:top>
                            <v-toolbar flat dense>
                                <v-toolbar-title center>
                                    <font color="Red">
                                        GRUPO C
                                    </font>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                    </v-data-table>
                    <v-data-table :headers="headers" :items="partidosD" locale="es-ar" class="elevation-1"
                        :items-per-page="8" hide-default-footer dense>
                        <template v-slot:top>
                            <v-toolbar flat dense>
                                <v-toolbar-title center>
                                    <font color="Red">
                                        GRUPO D
                                    </font>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                    </v-data-table>
                    <!-- <v-data-table
                :headers="headers"
                :items="partidosE"
                locale="es-ar"
                class="elevation-1"
                :items-per-page="8"
                hide-default-footer
                dense
              >
                <template v-slot:top>
                  <v-toolbar flat dense>
                    <v-toolbar-title center>
                      <font color="Red">
                        GRUPO E
                      </font>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
              </v-data-table>
              <v-data-table
                :headers="headers"
                :items="partidosF"
                locale="es-ar"
                class="elevation-1"
                :items-per-page="8"
                hide-default-footer
                dense
              >
                <template v-slot:top>
                  <v-toolbar flat dense>
                    <v-toolbar-title center>
                      <font color="Red">
                        GRUPO F
                      </font>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
              </v-data-table>
              <v-data-table
                :headers="headers"
                :items="partidosG"
                locale="es-ar"
                class="elevation-1"
                :items-per-page="8"
                hide-default-footer
                dense
              >
                <template v-slot:top>
                  <v-toolbar flat dense>
                    <v-toolbar-title center>
                      <font color="Red">
                        GRUPO G
                      </font>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
              </v-data-table>
              <v-data-table
                :headers="headers"
                :items="partidosH"
                locale="es-ar"
                class="elevation-1"
                :items-per-page="8"
                hide-default-footer
                dense
              >
                <template v-slot:top>
                  <v-toolbar flat dense>
                    <v-toolbar-title center>
                      <font color="Red">
                        GRUPO H
                      </font>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
              </v-data-table> -->

                </v-card>
            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import axios from "../../../axios-auth";
import moment from "moment";
//import UploadService from "../../services/UploadFilesService";
import Compressor from "compressorjs";

export default {
    data: (vm) => ({
        valid: false,
        lazy: false,
        //increase: [0, 6, 12, 18, 24, 30, 36, 42],
        increase: [0, 6, 12, 18],
        //increaseA: [0, 1, 2, 3, 4, 5],
        increaseA: [0, 1, 2, 3],
        //items: ["A", "B", "C", "D", "E", "F", "G", "H"],
        items: ["A", "B", "C", "D"],
        partidosA: [],
        partidosB: [],
        partidosC: [],
        partidosD: [],
        partidosE: [],
        partidosF: [],
        partidosG: [],
        partidosH: [],
        posicionA: [],
        posicionB: [],
        posicionC: [],
        posicionD: [],
        posicionE: [],
        posicionF: [],
        posicionG: [],
        posicionH: [],
        ranking: [],
        headers: [
            {
                text: "Código",
                width: "5%",
                align: "center",
                sortable: false,
                value: "idresultado",
            },
            {
                text: "Equipo",
                width: "20%",
                value: "equipo1",
                align: "right",
                sortable: false,
            },
            {
                text: "",
                width: "5%",
                align: "center",
                value: "goles1",
                sortable: false,
            },
            {
                text: "",
                width: "5%",
                align: "center",
                value: "goles2",
                sortable: false,
            },
            { text: "Equipo", width: "20%", value: "equipo2", sortable: false },
        ],
        fecha: moment().format("DD/MM/YYYY"),
        //increase: [0, 6, 12, 18, 24, 30, 36, 42],
        //items: ["A", "B", "C", "D", "E", "F", "G", "H"],
        increase: [0, 6, 12, 18],
        items: ["A", "B", "C", "D"],
        equipos: [],
        prode: [],
        idresultados: [],
    }),
    // watch: {
    //   select: function(val) {
    //     this.cargarResultadoLegajo();
    //   },
    // },
    props: ["visible", "legajo"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.responsable = this.$store.state.nombre.toString().trim();
                    this.cargarResultado();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    //this.$refs.form.resetValidation();
                    //this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
        isActive() {
            return false;
        },
    },

    methods: {
        cargarResultado() {
            const legajo = this.legajo;
            let self = this;
            console.log(this.legajo)
            axios
                .get("/App/GetProdeLegajo?", {
                    params: {
                        filtrolegajo: legajo,
                    },
                })
                .then((response) => {

                    response.data.forEach((element) => {
                        if (element.idresultado <= "6") {
                            self.partidosA.push(element);
                            console.log(self.partidosA[0].goles1)
                        }
                        if (element.idresultado >= "7" && element.idresultado <= "12") {
                            self.partidosB.push(element);
                        }
                        if (element.idresultado >= "13" && element.idresultado <= "18") {
                            self.partidosC.push(element);
                        }
                        if (element.idresultado >= "19" && element.idresultado <= "24") {
                            self.partidosD.push(element);
                        }
                        // if (element.idresultado >= "25" && element.idresultado <= "30") {
                        //   self.partidosE.push(element);
                        // }
                        // if (element.idresultado >= "31" && element.idresultado <= "36") {
                        //   self.partidosF.push(element);
                        // }
                        // if (element.idresultado >= "37" && element.idresultado <= "42") {
                        //   self.partidosG.push(element);
                        // }
                        // if (element.idresultado >= "43" && element.idresultado <= "48") {
                        //   self.partidosH.push(element);
                        // }
                    });
                })
                .catch((error) => {
                    self.equipos = [];
                    console.log(error);
                });
        },
    },
};
</script>